export default __webpack_public_path__ + "static/media/log-out.8dd9d9ce.svg";